// Draws month calendars for the availability page from data-ranges ("YYYY-MM-DD~YYYY-MM-DD,...").
(() => {
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  const MAX_MONTHS = 6;
  const iso = (y, m, d) => `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

  document.querySelectorAll('[data-mk-avail]').forEach((root) => {
    const cal = root.querySelector('[data-mk-avail-cal]');
    const ranges = (root.dataset.ranges || '').split(',').filter(Boolean).map((r) => r.split('~'));
    if (!cal || !ranges.length) return;

    const now = new Date();
    const today = iso(now.getFullYear(), now.getMonth(), now.getDate());
    const lastEnd = ranges.reduce((max, [, e]) => (e > max ? e : max), today);
    const isBooked = (d) => ranges.some(([s, e]) => d >= s && d <= e);

    let y = now.getFullYear();
    let m = now.getMonth();
    const endKey = lastEnd.slice(0, 7);
    let html = '';
    for (let i = 0; i < MAX_MONTHS && iso(y, m, 1).slice(0, 7) <= endKey; i++) {
      const first = new Date(y, m, 1).getDay();
      const count = new Date(y, m + 1, 0).getDate();
      let cells = '<tr>' + '<td></td>'.repeat(first);
      for (let d = 1; d <= count; d++) {
        const key = iso(y, m, d);
        const cls = [isBooked(key) && 'is-booked', key < today && 'is-past', key === today && 'is-today'].filter(Boolean).join(' ');
        cells += `<td${cls ? ` class="${cls}"` : ''}>${d}</td>`;
        if ((first + d) % 7 === 0 && d < count) cells += '</tr><tr>';
      }
      cells += '</tr>';
      html += `<table class="mk-cal"><caption>${MONTHS[m]} ${y}</caption><thead><tr>${DAYS.map((d) => `<th>${d}</th>`).join('')}</tr></thead><tbody>${cells}</tbody></table>`;
      if (++m > 11) { m = 0; y++; }
    }
    cal.innerHTML = html + '<p class="mk-cal__legend"><span></span>Booked</p>';
  });
})();
